import * as yup from 'yup'

export const inviteSignupSchema = yup
    .object({
        email: yup.string().email('Please enter valid email').required(),
        password: yup
            .string()
            .min(8, 'Password should be at least 8 characters long')
            .matches(/^.*[a-z]+.*$/, 'Must contain at least 1 lower case letter')
            .matches(/^.*[A-Z]+.*$/, 'Must contain at least 1 upper case letter')
            .matches(/^.*[0-9]+.*$/, 'Must contain at least 1 number')
            .max(50, 'Password can not be longer than 50 characters')
            .required(),
        confirmPassword: yup
            .string()
            .oneOf([yup.ref('password')], 'Passwords must match')
            .required(),
        tnc: yup.boolean().oneOf([true], 'Please accept the terms and conditions').required(),
    })
    .required()

export type InviteSignupFormValues = yup.InferType<typeof inviteSignupSchema>
